import supabase from "../supabaseClient";

/**
 * Check if a job order already exists in the database
 * Returns true if it exists, false otherwise
 */
export const checkJobOrderExists = async (jobOrder) => {
  try {
    const { data, error } = await supabase
      .from("shipments")
      .select("job_order")
      .eq("job_order", jobOrder);

    if (error) throw error;
    return data && data.length > 0;
  } catch (err) {
    console.error("Error checking job order:", err);
    throw err;
  }
};

/**
 * Consolidated job order generation utility
 * Generates job order codes based on shipment type and parameters
 */
export const generateJobOrder = async (shipmentDetails) => {
  const { type, shipment_transport, shipment_mode, shipment_bound } = shipmentDetails;

  try {
    const currentMonth = new Date().toISOString().slice(5, 7);
    const currentYear = new Date().toISOString().slice(2, 4);

    let prefix = null;

    // Determine prefix based on shipment type and parameters
    if (type === "AIR" || type === "SEA") {
      // AIR/SEA with IMPORT/EXPORT modes
      if (shipment_mode === "IMPORT-EVENT" || shipment_mode === "EXPORT-EVENT") {
        prefix = "PJ";
      } else if (type === "AIR") {
        prefix = shipment_mode === "EXPORT" ? "AE" : "AI";
      } else if (type === "SEA") {
        prefix = shipment_mode === "EXPORT" ? "SE" : "SI";
      }
    } else if (type === "DOMESTIC") {
      // DOMESTIC with INBOUND/OUTBOUND
      if (shipment_bound === "OUTBOUND") {
        prefix = `${shipment_bound[0]}${shipment_transport[0]}`;
      } else if (shipment_bound === "INBOUND") {
        prefix = `${shipment_bound[0]}${shipment_transport[0]}`;
      }
    } else if (type === "LAND") {
      // LAND type
      prefix = "LT";
    } else if (shipment_transport && type) {
      // Other types with transport
      prefix = `${type[0]}${shipment_transport[0]}`;
    }

    // If no prefix could be determined, return null
    if (!prefix) {
      return null;
    }

    // Query existing job orders with the same prefix pattern
    const { data: jobOrders, error } = await supabase
      .from("shipments")
      .select("job_order")
      .ilike("job_order", `${prefix}${currentMonth}%${currentYear}`);

    if (error) throw error;

    // Find the highest existing number
    const existingJobOrders = jobOrders || [];
    const lastNumber =
      existingJobOrders
        .map((order) =>
          parseInt(
            order.job_order
              .replace(`${prefix}${currentMonth}`, "")
              .replace(`${currentYear}`, ""),
            10
          )
        )
        .filter((num) => !isNaN(num))
        .sort((a, b) => b - a)[0] || 0;

    // Generate new job order with incremented number
    const increment = String(lastNumber + 1).padStart(2, "0");
    const newJobOrder = `${prefix}${currentMonth}${increment}${currentYear}`;

    return newJobOrder;
  } catch (err) {
    console.error("Error generating job order:", err);
    throw err;
  }
};
